import { render, staticRenderFns } from "./ViewStaff.vue?vue&type=template&id=3b9e9a3e&"
import script from "./ViewStaff.vue?vue&type=script&lang=ts&"
export * from "./ViewStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports